import { render, staticRenderFns } from "./AnswerKey.vue?vue&type=template&id=daebb6bc&scoped=true&"
import script from "./AnswerKey.vue?vue&type=script&lang=js&"
export * from "./AnswerKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daebb6bc",
  null
  
)

export default component.exports